import domain, { baseDomain, isCn as cn, isCom as com } from '@liepin/native-domain-fe';

export const rootDomain = baseDomain;
export const mRoot = domain('m');
export const cRoot = domain('c');
export const mcRoot = domain('m-c');
export const mVasRoot = domain('m-vas');
export const passportRoot = domain('passport');
export const wwwRoot = domain('www');
export const wowRoot = domain('wow');
export const cashierRoot = domain('cashier');
export const mCashierRoot = domain('m-cashier');
export const vapRoot = domain('vap');
export const openRoot = domain('open');
export const vasRoot = domain('vas');
export const mVapRoot = domain('m-vap');
export const tongdaoRoot = domain('tongdao');
export const eventRoot = domain('event');
export const basepassportRoot = domain('basepassport');
export const appTongdaoRoot = domain('app-tongdao');
export const mxyRoot = domain('mxy');
export const campusRoot = domain('campus');
export const lptRoot = domain('lpt');
export const cltRoot = domain('clt');
export const hRoot = domain('h');
export const apicRoot = domain('apic');
export const cnutsRoot = domain('cnuts');
export const accountRoot = domain('account');
export const mAccountRoot = domain('m-account');
export const irRoot = domain('ir');
export const jobRoot = domain('job');
export const companyRoot = domain('company');

export const getDomain = domain;
export const isCn = cn;
export const isCom = com;
